import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
import { ProjectModule } from "@/store/modules/project.module";
const projectsMachine = Machine({
    id: "projectsMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "name",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_PROJECTS: { target: "gettingProjects", actions: "assignSearchData" },
            },
        },
        gettingProjects: {
            tags: "gettingProjects",
            invoke: {
                id: "gettingProjects",
                src: (context, event) => {
                    return ProjectModule.GetProjectListings(context.searchData);
                },
                onDone: { target: "loadedProjects" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedProjects: {
            on: {
                GETTING_PROJECTS: { target: "gettingProjects", actions: "assignSearchData" },
                ADD_PROJECT: { target: "addProject" },
                DELETE_PROJECT: { target: "deleteProject", actions: "ispageChanged" },
            },
        },
        addProject: {
            tags: "showAddProjectModal",
            on: {
                ADDING_PROJECT: { target: "addingProject" },
                CLOSE_MODAL: { target: "loadedProjects" },
            },
        },
        addingProject: {
            tags: "showAddProjectModal",
            invoke: {
                id: "addingProject",
                src: (context, eve) => {
                    return ProjectModule.CreateProject(eve.project);
                },
                onDone: { target: "gettingProjects", actions: "showSuccessMessage" },
                onError: { target: "loadedProjects" },
            },
        },
        deleteProject: {
            tags: "showDeleteProjectUI",
            on: {
                DELETING_PROJECT: { target: "deletingProject" },
                CLOSE_MODAL: { target: "loadedProjects" },
            },
        },
        deletingProject: {
            tags: "showDeleteProjectUI",
            invoke: {
                id: "deletingProject",
                src: (context, eve) => {
                    return ProjectModule.DeleteProjectById(eve.projectId);
                },
                onDone: { target: "gettingProjects", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedProjects" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    const updatedSearchData = {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                    ProjectModule.AssignSearchParams(updatedSearchData);
                    return updatedSearchData;
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default projectsMachine;
